<ion-content>
  <div class="checkmark-design">
    <ion-icon name="checkmark"></ion-icon>
  </div>
  <h1 class="title-text">
    {{'pay-confirmation.Your' | translate}} <br />
    {{'pay-confirmation.successful' | translate}}
  </h1>
  <div class="notes">
    <p>{{'pay-confirmation.page' | translate}}</p>
    <p>{{'pay-confirmation.play' | translate}}</p>
  </div>

  <ion-button size="small" expand="block" class="action-btn-large" type="submit"
    (click)="startSpinner()">
    @if (!isRedirected) {
      {{'pay-confirmation.Next' | translate}}
    }
    @if (isRedirected) {
      <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
      style="color: white; margin-right: 1vh"></ion-spinner>
    }
  </ion-button>
</ion-content>